export default "__VITE_ASSET__5T7E4A0dBTTuVqq_9C8g1Q__";